const deliveries = [
    {
        value: 'courier',
        name: 'Pristatymas į namus per kurjerių tarnybą',
        info:
            'Perdavę prekes kurjeriui, informuosime Jus SMS žinute bei el. paštu. Prieš atvažiuodamas, kurjeris Jus informuos skambučiu arba SMS žinute apie planuojamą pristatymo laiką.'
    },
    {
        value: 'omniva',
        name: 'Atsiėmimas Omniva paštomate',
        info:
            'Prašome atvykti atsiimti užsakymo tik gavę SMS žinutę ar pranešimą el. paštu, kad Jūsų užsakymas jau pristatytas į Jūsų pasirinktą Omniva skyrių.'
    },
    {
        value: 'dpd',
        name: 'Atsiėmimas DPD terminale',
        info:
            'Prašome atvykti atsiimti užsakymo tik gavę SMS žinutę ar pranešimą el. paštu, kad Jūsų užsakymas jau pristatytas į Jūsų pasirinktą DPD skyrių.'
    },
    {
        value: 'lpexpress',
        name: 'Atsiėmimas LP EXPRESS terminale',
        info:
            'Prašome atvykti atsiimti užsakymo tik gavę SMS žinutę ar pranešimą el. paštu, kad Jūsų užsakymas jau pristatytas į Jūsų pasirinktą LP EXPRESS siuntų savitarnos terminalą.'
    },
    {
        value: 'venipak',
        name: 'Atsiėmimas Venipak punkte',
        info:
            'Prašome atvykti atsiimti užsakymo tik gavę SMS žinutę ar pranešimą el. paštu, kad Jūsų užsakymas jau pristatytas į Jūsų pasirinktą Venipak punktą.'
    },
    {
        value: 'itella',
        name: 'Atsiėmimas Itella punkte',
        info:
            'Prašome atvykti atsiimti užsakymo tik gavę SMS žinutę ar pranešimą el. paštu, kad Jūsų užsakymas jau pristatytas į Jūsų pasirinktą Itella punktą.'
    },
    {
        value: 'post_office',
        name: 'Atsiėmimas Lietuvos pašto skyriuje',
        info:
            'Prašome atvykti atsiimti užsakymo tik gavus pranešimą SMS žinute ar el. paštu, kad Jūsų užsakymas jau pristatytas į pasirinktą Lietuvos pašto skyrių.'
    },
    {
        value: 'from_address',
        name: 'Atsiėmimas iš nurodyto adreso',
        info: 'Prekes atsiimkite šiuo adresu: '
    },
    {
        value: 'bus_station',
        name: 'Atsiėmimas autobusų stotyje',
        info:
            'Pristatymo išlaidas reikės apmokėti atsiimant prekes autobusų stotyje. * pažymėtuose sustojimuose siuntą autobuso atvykimo laiku reikia atsiimti iš vairuotojo'
    },
    {
        value: 'eu',
        name: 'Siuntimas į kitas Europos Sąjungos šalis'
    },
    {
        value: 'global',
        name: 'Siuntimas į kitas ne Europos Sąjungos šalis'
    }
]

export default deliveries
